import { Image } from "antd";
import Button from "../Reusable Elements/Button";
import { demoImages } from "../../data/galleryData";

export default function DemoGallery() {
    return (
        <div className="pt-8">
            <div className="font-poppins text-primary-blue font-extralight text-5xl text-center">
                Gallery
            </div>
            <div className="w-full flex justify-center flex-wrap gap-3 mt-8 sm:px-40">
                {demoImages.map((src, index) => (
                    <Image
                        key={index}
                        width={300}
                        height={300}
                        src={src}
                        style={{ zIndex: "1" }}
                    />
                ))}
            </div>
            <div className="w-full flex justify-center pt-12 pb-8">
                <Button
                    text={"Explore more"}
                    color={"#022051"}
                    location={"/gallery"}
                />
            </div>
        </div>
    );
}
